export enum SensitivityType {
    EXCLUSION = "exclusion",
    DOWNSIZE = "downsize"
}
